/** Textos amigables para pantallas y errores (sin códigos de permiso ni rutas de API). */

export const MSG_SIN_ACCESO_REPORTES =
  'No tenés acceso a los reportes. Pedí al administrador que te habilite la consulta de informes.';

export const MSG_SIN_ACCESO_CREDITOS_VER =
  'No podés consultar créditos con tu perfil actual. Pedí acceso al administrador.';

export const MSG_SIN_ACCESO_CREDITOS_CREAR =
  'No podés crear créditos con tu perfil actual. Pedí acceso al administrador.';

export const MSG_SIN_ACCESO_CREDITOS_PAGAR =
  'No podés registrar cobros con tu perfil actual. Pedí acceso al administrador.';

export const MSG_SIN_ACCESO_CAJA =
  'No podés gestionar la caja con tu perfil actual. Pedí acceso al administrador.';

export const MSG_SIN_ACCESO_USUARIOS_GESTION =
  'Podés ver el listado, pero no crear ni editar usuarios. Pedí acceso de administración.';

export const MSG_SIN_ACCESO_ROLES_GESTION =
  'Podés ver los roles, pero no crearlos ni cambiar permisos. Pedí acceso de administración.';

export const MSG_SIN_ACCESO_CLIENTES_EDITAR =
  'No podés modificar datos de clientes. Pedí acceso de edición al administrador.';

export const MSG_SIN_ACCESO_COBRANZA =
  'No tenés acceso a la cola de cobranza. Pedí al administrador que te habilite esta sección.';

export const MSG_SIN_ACCESO_GENERICO =
  'No tenés acceso para esta acción. Pedí al administrador que revise tu rol.';

export const MSG_SIN_CONEXION =
  'Sin conexión. Revisá tu internet e intentá de nuevo.';

const MAPA_PERMISO_AMIGABLE: Record<string, string> = {
  'REPORTES:VER': MSG_SIN_ACCESO_REPORTES,
  'REPORTES:GESTIONAR': MSG_SIN_ACCESO_REPORTES,
  'CREDITOS:VER': MSG_SIN_ACCESO_CREDITOS_VER,
  'CREDITOS:CREAR': MSG_SIN_ACCESO_CREDITOS_CREAR,
  'CREDITOS:PAGAR': MSG_SIN_ACCESO_CREDITOS_PAGAR,
  'CAJA:VER': MSG_SIN_ACCESO_CAJA,
  'CAJA:GESTIONAR': MSG_SIN_ACCESO_CAJA,
  'SEGURIDAD:VER': MSG_SIN_ACCESO_GENERICO,
  'SEGURIDAD:GESTIONAR': MSG_SIN_ACCESO_USUARIOS_GESTION,
  'CLIENTES:EDITAR': MSG_SIN_ACCESO_CLIENTES_EDITAR,
  'COBRANZA:VER': MSG_SIN_ACCESO_COBRANZA,
  'COBRANZA:GESTIONAR': MSG_SIN_ACCESO_COBRANZA,
  'LEGAL:VER': MSG_SIN_ACCESO_GENERICO,
  'LEGAL:GESTIONAR': MSG_SIN_ACCESO_GENERICO,
  'INVENTARIO:VER': MSG_SIN_ACCESO_GENERICO,
  'INVENTARIO:GESTIONAR': MSG_SIN_ACCESO_GENERICO,
  'CONFIG:EDITAR': MSG_SIN_ACCESO_GENERICO,
  'ORGANIZACION:VER': MSG_SIN_ACCESO_GENERICO,
};

function extraerParPermiso(texto: string): string | null {
  const m = texto.match(/\b([A-Z][A-Z0-9_]*):([A-Z][A-Z0-9_]*)\b/);
  return m ? `${m[1]}:${m[2]}` : null;
}

/** Convierte respuestas del API con códigos técnicos en texto para usuario final. */
export function mensajeApiAmigable(raw: string): string {
  const t = raw.trim();
  if (!t) return MSG_SIN_ACCESO_GENERICO;

  const par = extraerParPermiso(t);
  if (par && MAPA_PERMISO_AMIGABLE[par]) return MAPA_PERMISO_AMIGABLE[par];

  if (/permiso\s+denegado/i.test(t) || (par != null && /se\s+requiere/i.test(t))) {
    return MSG_SIN_ACCESO_GENERICO;
  }

  if (/monto_pagado|codigo_generacion|turno_id|cuota_id|permiso_ids|PRESTAMO_EFECTIVO/i.test(t)) {
    return 'No se pudo completar la operación. Revisá los datos ingresados o pedí ayuda al administrador.';
  }

  if (/^sin conexi[oó]n/i.test(t) || /revis[aá].*api/i.test(t)) {
    return MSG_SIN_CONEXION;
  }

  return t;
}
